import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { cloneElement } from 'react';
import createComponent from 'intergalactic/core';
import { getNodeByRef, useForkRef } from 'intergalactic/utils/lib/ref';
import ownerDocument from 'intergalactic/utils/lib/ownerDocument';
import useEventCallback from 'intergalactic/utils/lib/use/useEventCallback';
import getOriginChildren from 'intergalactic/utils/lib/getOriginChildren';
import { getEventTarget } from 'intergalactic/utils/lib/getEventTarget';

/** @deprecated */

var noop = function noop() {};
function OutsideClick(props) {
  var Children = props.Children,
    forwardRef = props.forwardRef,
    root = props.root,
    _props$excludeRefs = props.excludeRefs,
    excludeRefs = _props$excludeRefs === void 0 ? [] : _props$excludeRefs,
    _props$onOutsideClick = props.onOutsideClick,
    onOutsideClick = _props$onOutsideClick === void 0 ? noop : _props$onOutsideClick;
  var children = getOriginChildren(Children);
  var nodeRef = React.useRef(null);
  var targetRef = React.useRef(null);
  var handleRef = useForkRef(children ? children.ref : null, nodeRef, forwardRef);
  var handleOutsideClick = useEventCallback(function (event) {
    var isTargetEvent = [].concat(_toConsumableArray(excludeRefs), [nodeRef]).filter(function (node) {
      return getNodeByRef(node);
    }).some(function (node) {
      var _getNodeByRef;
      return (_getNodeByRef = getNodeByRef(node)) === null || _getNodeByRef === void 0 ? void 0 : _getNodeByRef.contains(targetRef.current || getEventTarget(event));
    });
    if (!isTargetEvent) {
      onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick(event);
    }
  });
  var handleMouseDown = useEventCallback(function (event) {
    targetRef.current = getEventTarget(event);
  });
  React.useEffect(function () {
    var outsideRoot = root ? getNodeByRef(root) : ownerDocument(nodeRef.current);

    // Using capture to handle event faster than OutsideClick handler
    outsideRoot === null || outsideRoot === void 0 ? void 0 : outsideRoot.addEventListener('mouseup', handleOutsideClick, true);
    outsideRoot === null || outsideRoot === void 0 ? void 0 : outsideRoot.addEventListener('mousedown', handleMouseDown, true);
    return function () {
      outsideRoot === null || outsideRoot === void 0 ? void 0 : outsideRoot.removeEventListener('mouseup', handleOutsideClick, true);
      outsideRoot === null || outsideRoot === void 0 ? void 0 : outsideRoot.removeEventListener('mousedown', handleMouseDown, true);
    };
  }, [root]);
  return children ? /*#__PURE__*/cloneElement(children, {
    ref: handleRef
  }) : null;
}
OutsideClick.displayName = 'OutsideClick';
export default createComponent(OutsideClick);
//# sourceMappingURL=OutsideClick.js.map